import { useTranslation } from "react-i18next";

import { Badge } from "@/components/ui/badge";
import type { CaseStatus } from "@/domain/case/case";

/**
 * 案件ステータスの表示。ラベルは domain 名前空間（issue #24 の用語表）を唯一の情報源にする。
 *
 * 色は「注意を引くべきか」で選ぶ:
 * - returned / error は destructive（起票者の対応が必要）
 * - completed は secondary（済んだもの・視線を奪わない）
 * - それ以外は outline
 */
const VARIANT_BY_STATUS: Readonly<
  Record<CaseStatus, "default" | "secondary" | "destructive" | "outline">
> = {
  draft: "outline",
  inProgress: "default",
  returned: "destructive",
  completed: "secondary",
  canceled: "outline",
  suspended: "outline",
  error: "destructive",
};

export function CaseStatusBadge({ status }: { status: CaseStatus }) {
  const { t } = useTranslation("domain");

  return (
    <Badge variant={VARIANT_BY_STATUS[status]}>
      {t(`caseStatus.${status}`)}
    </Badge>
  );
}
